<template>
  <div class="info-flyout">
    <!-- Toggle button -->
    <div
      :class="{
        'toggle-button': true,
        'info-flyout__toggle-button': true,
        'info-flyout__toggle-button--no-bottom-margin': !isOpened,
      }"
      @click="isOpened = !isOpened"
    >
      <IconEmbedded v-if="!isOpened" class="toggle-button__caret-icon" name="caret-bottom_4" :size="14" color="rgba(17, 134, 137, 1)" />
      <IconEmbedded v-else class="toggle-button__caret-icon" name="caret-top_4" :size="14" color="rgba(17, 134, 137, 1)" />

      <div class="toggle-button__divider"></div>

      <IconEmbedded class="toggle-button__bulb-icon" name="bulb_2-5" :size="17" color="rgba(17, 134, 137, 1)" />
      <div class="toggle-button__text">How Custom Collabs Work</div>
    </div>
    <!-- / Toggle button -->

    <TransitionedHeightAuto :isOpened="isOpened">
      <div class="info-flyout__content">
        <div class="info-flyout__content-left-col">
          <!--<div class="info-flyout__plain-text">
            {{ `Shrpa helps facilitate but you're in the driver's seat for who you work with, what the deliverables are, and how you compensate.` }}
          </div>-->

          <ul class="info-flyout__stages-list">
            <!-- Stage snippet -->
            <li
              :class="{
                'stage-snippet': true,
                'stage-snippet--first': index === 0,
                'stage-snippet--last': index === stagesList.length - 1,
                'info-flyout__stage-snippet': true,
              }"
              v-for="(stage, index) in stagesList"
              :key="stage.title"
            >
              <div class="stage-snippet__number">
                {{ index + 1 }}
              </div>
              <div class="stage-snippet__text-container">
                <h4 class="global-h4 stage-snippet__title">
                  {{ stage.title }}
                </h4>
                <div class="stage-snippet__description">
                  {{ stage.description }}
                </div>
              </div>
            </li>
            <!-- / Stage snippet -->
          </ul>
        </div>

        <div class="info-flyout__content-right-col">
          <h3 class="global-h3" style="margin-bottom: 10px">FAQ</h3>
          <ul class="global-ul">
            <li>You invite and coordinate with the creator.</li>
            <li>You pay/comp the creator directly. (in-platform payments coming soon)</li>
            <li>Do as many custom collabs as you want!</li>
            <li>Shrpa Creator Visits are a structured alternative to custom collabs.</li>
          </ul>
        </div>
      </div>
    </TransitionedHeightAuto>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

// Components
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import TransitionedHeightAuto from "@components/ui/TransitionedHeightAuto.vue";

// Stages list ================================================================
const stagesList = [
  {
    title: "Find a Creator to Work With",
    description: "Identify a creator you'd like to work with, or use someone who has reached out with a proposal.",
  },
  {
    title: "Propose High-Level Collaboration Details",
    description: "Propose the concept for the work, or ask them to pitch you a concept.",
  },
  {
    title: "Communicate and Formalize the Collab Agreement",
    description: "Discuss the scope of the work, the deliverables, and compensation.",
  },
  {
    title: "Creator Delivers Agreed Content",
    description: "The creator completes and delivers the work (you can request edits as needed).",
  },
];

// Is Opened ==================================================================
const isOpened = ref<boolean>(false);
</script>

<style scoped lang="scss">
@import "@/scss/howDoesItWorkSpoiler.scss";
</style>
